import React from 'react';

const TextArea = React.forwardRef(({ className, label, error, ...textAreaRest }, ref) => {

    return <div className='w-full flex flex-col relative mb-2 mt-2'>
        {label && <div className="bg-white ">
            <span className="relative text-xs text-gray-500 uppercase tracking-wide">{label}</span>
        </div>}
        <textarea
            className={`w-full h-16 py-2 px-3 text-sm border border-solid border-gray-300 rounded focus:outline-none focus:border-gray-600  ${className}`}
            {...textAreaRest}
            ref={ref}
        />
        {error?.message && <div className='text-xs text-pink-800'>{error?.message}</div>}
    </div>
});

export default TextArea;